export enum ModalID {
  confirmation,
  linkedFormCompleters,
  linkedFormGenerationStatuses,
  linkedFormViewers,
  manageStatuses,
  printPage,
  pickStyle,
  statusChangeAvailableStatuses,
  confirmDelete,
  linkedLicense,
  unlinkDocType,
  inviteMember,
  resendStatus,
  deleteInvitation,
  editGroup,
  bulkWorkflowActionError,
  bulkWorkflowActionConfirmation,
  confirmResendInvitation,
  createBulkWorkflowAction,
  deleteSubmission,
  confirmDeleteNotification,
  selectColumns,
  createConnectionSync,
  destroyRole,
  changePassword,
  chooseColor,
  actionInitiators,
  formulaFunctions,
  formFields,
  confirmSave,
  removeMembership,
  addNewNotification,
  confirmDateModeChange,
  confirmRepeatableChange,
  conditionalDisplay,
  createNewWorkflowStep,
  moveWorkflowStep,
  copyWorkflowStep,
  linkWorkflowStep,
  pickWorkflowBranch,
  deleteWorkflowStep,
  confirmDownloadCertificate,
  destroyItemAssociateToLicense,
  destroyCorrespondence,
  confirmFormatChange,
  publishVersion,
  unpublishVersion,
  confirmWorkflowStepDeletion,
  revertToOlderVersion,
  requestPublishVersion,
  requestUnpublishVersion,
  cancelRequestPublish,
  backupVersion,
  addSalesforceConnection,
  createUserRole,
  editUserRoles,
  removeYourPermissionsRoles,
  transferRemove,
  transferOwner,
  transferCurrentOwnership,
  addOrganization,
  createPortal,
  dynamicContentPopup,
  dynamicContentPopup2,
  approveRequest,
  rejectRequest,
  validationInform,
  shareDocument,
  selectPaymentGateway,
  removeUser,
  archiveDocument,
  renameDocument,
  copyDocument,
  addFolder,
  renameFolder,
  destroyFolder,
  folderContextMenu,
  destroyGroup,
  renameGroup,
  confirmDeleteDependencies,
  incorrectImageNotification,
  renameVersion,
  removeVersion,
  createTemplate,
  fieldPicker,
  mergeVersions,
  removeDocument,
  manageTags,
  linkExistingForm,
  linkNewForm,
  destroyPortal,
  createGroup,
  inputData,
  exportFiles,
  formulaEditor,
  assignCompleter,
  reassignCompleter,
  validationInCertificate ,
  editInvoice,
  addLineItem,
  connectionCreate,
  connectionConfirmDelete,
  createFolder,
  createDocument,
  switchOrganization,
  createOrganization,
  joinOrganization,
  sortableContextMenu,
  printSubmission,
  configureSidebar,
  addBookmark,
  changeSourceDestination,
  createSource,
  chooseMappingFields,
  modelMappingValueContextMenu,
  editSourceDestination,
  editActionConfirmation,
  discardObjectModelEntry,
  confirmDeleteObjectModelProperty,
  confirmDeleteObjectModelRelationship,
  connectionSyncCreate,
  connectionSyncConfirmDelete,
  connectionSyncConfirmRun,
  confirmChange,
  confirmObjectModelAction,
  deleteEntityType,
  deleteEntityTypeRoleView,
  editEntityTypeRoleViewDashboardName,
  objectModelActionError,
  objectModelActionCustomNotification,
  features,
  objectModelPrerequisitesContextMenu,
  savingRecord,
  changeRecordHolder,
  multipleSubmissions,
  detailViewPermissionsGroupContextMenu,
  changeCertificateMappingSource,
  certificateMappingSortBy,
  seeUnderlyingProperties,
  deleteCertificatePageModal,
  confirmDeleteCertificateDynamicInput,
  debugTracerCreate,
  debugTracerConfirmDelete,
  certificateMappingRelatedModels,
  visualizationNew,
  visualizationSelect,
  editAnalyticsName,
  confirmArchiveAnalytic,
  customizeDisplay,
  dashboardNew,
  validationInDashboard,
  setRanges,
  deleteFoundationLayerModal,
  setDateRange,
  publishDashboard,
  archiveCertificateWithDependents,
  pivotTableExpansion,
  barGraphExpansion,
  validationInProcessFlow,
  processFlowUpdateVariable,
  debugVariableModal,
  newProcessFlowStep,
  generateDocument,
  GenerateDocumentV2,
  mapDocumentInputs,
  dataPointReference,
  dataSourceFormUpdated,
  analyticOlderVersionAttention,
  visualizationChangedIndexedFields,
  ConfigProcessFlowSetDataModal,
  ConfigProcessFlowSaveDataModal,
  ConfigProcessFlowDeleteDataModal,
  ConfigProcessFlowRunProcessModal,
  ConfigureProcessFlowIterationStep,
  ConfigureProcessFlowTakeActionStep,
  deleteProcessFlowStep,
  configureProcessFlowWorkflowStep,
  configureObjectModelProcessFlow,
  assignActionableItems,
  userChangeStatus,
  removeObjectModelPermissionPermittee,
  filterPermissionPermitteesMenu,
  ConfigProcessFlowFindDataModal,
  changeRelatedUser,
  detailViewEditModeConfirmDiscard,
  configureExportCSVStep,
  apiConnection,
  connectionEndPointCreate,
  connectionEndPointConfirmDelete,
  connectionEndPointTest,
  connectionEndPointTestResponse,
  connectionEndPointTestExtractResponse,
  updatingRecords,
  recordsUpdated,
  exportListViewModal,
  generateNewApiKey,
  regenerateApiKey,
  renameApiKey,
  deleteApiKey,
  ConfigProcessFlowFindCountModal,
  ConfigApiRequest,
  relationSectionDisconnect,
  ConfigProcessFlowSendNotificationStep,
  paymentUserDefinedFields,
  downloadFolder,
  restoreFolder,
  ProcessFlowSendNotificationAttachDocumentDynamicContent,
  editUserTypeViewDashboardName,
  deleteUserTypeView,
  publishModal,
  confirmPublishModal,
  customizeDisplayAccountRelationship,
  invitePeerOrganization,
  acceptPeerOrganization,
  rejectPeerOrganization,
  removePeerOrganization,
  quickJump,
  ConfigProcessFlowDisplayAForm,
  sharePeerOrganizationDocument,
  unsharePeerOrganizationDocument,
  ProcessFlowSubmissionApp, // used for process flows with user interactions enabled
  ConfigureSectionModal,
  AddSubmissionCommentModal,
  createQuickLinkFolder,
  addQuickLinks,
  shareQuickLinkFolder,
  ConfigProcessFlowRedirect,
  createApplication,
  uploadApp,
  appDeployment,
  appDeploymentStatusFailed,
  appDeploymentSummary,
  verifiableFormElementConfirmation,
  discardFormSubmission,
  proposeFormSubmissionRevisionConfirmation,
  cancelFormSubmissionRevisionConfirmation,
  moveSubmissionStep,
  submittingSubmissionStep,
  confirmDeleteRepeatableWithUploads,
  cropImage,
  resumeExistingSubmission,
  exportProgress,
  destroyDataTag,
  createObjectModelRelationship,
  appGroupForm,
  groupDetailInvite,
  assignOrgGroupApps,
  groupDetailUpdateRoles,
  exportAppUserPermissionsModal,
  transferAppOwnership,
  convertToAppGroupWarning,
  removeAppGroupMembershipWizard,
  unassignAppGroupWarning,
  deleteAppGroupWizard,
}
